import React, { useEffect } from "react"
import DocumentMeta from "react-document-meta"
import { useNavigate, Link } from "react-router-dom"
import RosaSection from "../components/elements/BeigeSection"
import Header from "../components/Header"
import Footer from "../components/Footer"

const Terms: React.FC = () => {
	const navigate = useNavigate()

	// SEO Meta Tags

	const meta = {
		// title: "Mit merci zum Muttertag filmreif Danke sagen!",
		// canonical: "https://arvato-hawaiian-tropic-2023.de/",
		// meta: {
		// name: {
		// robots: "noindex, nofollow",
		// },
		// },
	}

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])

	return (
		<div>
			<div className="light">
				<Header type="logo" />
				<div className="text-back  mx-auto  py-8 ">
					<div className=" bg-[url(/src/bgimages/form-bg.png)] bg-cover py-8 mb-6">
						<h2 className="h2 mb-8 mt-12 text-center font-Alpro text-2xl text-white lg:mt-24">Teilnahmebedingungen</h2>
					</div>
					<div className="container max-w-[800px] mx-auto">
						<h3 className="h3 py-4 text-blue">1. Veranstalter</h3>
						<p className="mb-4 text-blue" >
							Die Cashback Aktion ist eine befristete Geld-zurück-Aktion in Deutschland mit den
							Joghurtalternativen der Marke Alpro. Veranstalter dieser Cashback-Aktion ist die
							Danone Deutschland GmbH, Am Hauptbahnhof 18, 60329 Frankfurt am Main,
							nachfolgend Danone genannt.
						</p>

						<h3 className="h3 py-4 text-blue">2. Teilnahmeberechtigung</h3>
						<p className="mb-4 text-blue" >
							Teilnahmeberechtigt sind Personen mit Wohnsitz in Deutschland, die bei der
							Teilnahme mindestens 18 Jahre alt sind und ein Konto im SEPA Raum (ein Land
							innerhalb der Europäischen Union sowie Island, Lichtenstein, Norwegen, Schweiz,
							Andorra, Monaco, San Marino, Vatikanstadt, Vereinigtes Königreich, Gibraltar, Isle
							of Man, Guernsey und Jersey) besitzen. Mitarbeiter von Danone, deren Angehörige
							und alle an der Konzeption und Umsetzung Cashback Aktion beteiligten Personen
							sind von der Teilnahme ausgeschlossen. Teilnehmer der Cashback Aktion ist
							diejenige Person, der die E-Mail-Adresse gehört, die bei der Anmeldung zum
							Cashback Aktion angegeben worden ist.
						</p>
						<p className="mb-4 text-blue" >
							Pro Bankkonto ist eine Teilnahme an dieser Cashback Aktion möglich. Pro
							Teilnahme ist nur ein Kaufbeleg anwendbar und es wird nur eine gekaufte
							Packung Alpro Joghurtalternative 400g erstattet. Die Teilnahme mittels
							automatisierter Datenverarbeitungsprozesse und/oder über die Einschaltung
							Dritter (z.B. von Gewinnspielagenturen) ist ausgeschlossen. Eine regelwidrige
							Teilnahme eines Teilnehmers an dieser Cashback Aktion hat seinen
							Spielausschluss zur Folge.
						</p>
						<p className="mb-4 text-blue" >
							Mit der Teilnahme an der Cashback Aktion akzeptiert der Benutzer diese
							Teilnahmebedingungen.
						</p>
						<p className="mb-4 text-blue" >
							Um an der Cashback Aktion teilzunehmen, muss der Teilnehmer innerhalb des
							unten genannten Kaufzeitraumes ein an der Aktion teilnehmendes Alpro Produkt
							(Joghurtalternative) im Handel oder online kaufen und den Kaufbeleg auf der
							Aktionswebsite <a href="https://www.alpro.com/de/campaign" target="_blank" className="underline">www.alpro.com/de/campaign</a> bis zum 08.05.2026, 23:59 Uhr
							hochladen und Pflichtfragen beantworten.
						</p>
						<p className="mb-4 text-blue" >
							Alle im Folgenden genannten Alpro Produkte (Joghurtalternativen), die in
							Deutschland gekauft wurden, nehmen an der Aktion teil:
							<br /><br />
							<ul>
								<li>Alpro®- Soja-Joghurtalternative Natur, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Natur mit Mandeln, 400g</li>
								<li>Alpro®- Soja-Joghurtalternative Natur mit Kokosnuss, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Natur mit Hafer, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Hafer+ Natur, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Natur Ohne Zucker, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative This is not Y*gurt, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Heidelbeere, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Vanille, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Pfirsich, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Kirsche, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Zitrone-Limette, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Erdbeere, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Erdbeere Banane, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Mango ohne Zuckerzusatz, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Ananas-Passionsfrucht ohne Zuckerzusatz, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Himbeere-Apfel ohne Zuckerzusatz, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Rote Früchte mit Datteln ohne Zuckerzusatz, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Dessert Style Apfelstrudel Geschmack, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Dessert Style Lemon-Cheesecake Geschmack, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Dessert Style Blueberry Muffin Geschmack, 400g  </li>
								<li>Alpro®- Soja-Joghurtalternative Skyr Natur ohne Zucker, 400g</li>
								<li>Alpro®- Soja-Joghurtalternative Skyr Vanille, 400g</li>
								<li>Alpro®- Soja-Joghurtalternative Skyr Mango, 400g</li>
							</ul>
						</p>
						<p className="mb-4 text-blue" >
							Hierbei ist zu beachten, dass „Alpro“, sowie das Kaufdatum schriftlich auf dem
							Kaufbeleg fixiert sein muss, um eine Nachvollziehbarkeit des Kaufs von Alpro
							Produkten (Joghurtalternative) im Aktionszeitraum sicherzustellen. Das Bild des
							Kassenbons ist als JPG, PNG oder PDF hochzuladen und darf die maximale
							Dateigröße von 8 MB nicht überschreiten. Der Kaufzeitraum ist vom 05.01.2026 - 08.05.2026.
							 Der Teilnahmezeitraum ist online möglich bis zum 08.05.2026, 23.59
							Uhr. Voraussetzung dafür ist ein gültiger Kassenbon, der den Kauf eines
							teilnehmenden Aktionsproduktes im Kaufzeitraum nachweist.
						</p>
						<p className="mb-4 text-blue" >
							Danone behält sich vor, den Originalkassenbon bis zum Ablauf der Aktion für
							etwaige Nachprüfungen einzufordern. Zu diesem Zweck muss der Teilnehmer den
							Kassenbon an Danone Deutschland GmbH bzw. die durchführende Agentur, direct
							services Gütersloh GmbH senden.
						</p>
						<h3 className="h3 py-4 text-blue">3. Cashback</h3>
						<p className="mb-4 text-blue" >
							Es wird nur der auf dem Kassenbon angegebene Kaufpreis für ein Alpro Produkt
							(Joghurtalternative) einmalig erststattet. Im Falle mehrerer gekaufter Alpro
							Produkte (Joghurtalternativen) auf einem Kassenbon wird das teuerste Alpro
							Produkt (Joghurtalternative) erstattet. Eine Kombination mit anderen Gutscheinen
							oder Aktionen ist nicht möglich. Auszahlungsansprüche sind nicht auf Dritte
							übertragbar.
						</p>
						<p className="mb-4 text-blue" >
							Danone erstattet einen Maximalbetrag von 2,29 Euro pro Aktionsprodukt.
						</p>
						<p className="mb-4 text-blue" >Dafür muss der Teilnehmer nach der Registrierung seinen Namen und seine IBAN
							im Teilnahmeformular angeben, sowie in einem Dropdown-Menü Pflichtfragen
							beantworten.  </p>
						<p className="mb-4 text-blue" >Der Betrag wird innerhalb von 4 Wochen auf das von ihm angegebene Bankkonto
							erstattet. Eventuelle Gebühren, die die kontoführende Bank des Teilnehmers für
							den Empfang des Geldes oder die Umrechnung von Euro in andere Währungen
							berechnet, hat der Kontoinhaber selbst zu tragen.  </p>
						<p className="mb-4 text-blue" >
							Die Aktion ist auf insgesamt 50.000 Teilnahmen begrenzt. Sollte die Aktion vorzeitig beendet sein wegen Erreichen der 50.000 Teilnahmen, wird dies auf{" "}
							<a href="https://www.alpro.com/de/campaign" target="_blank" className="underline">www.alpro.com/de/campaign</a> kommuniziert.
						</p>
						<h3 className="h3 py-4 text-blue">4. Rechte</h3>
						<p className="mb-4 text-blue" >Der Teilnehmer versichert, dass die eingereichten Daten von ihm selbst stammen,
							noch nicht anderweitig eingereicht worden sind und mit den eingereichten Daten
							nicht die guten Sitten, geltendes Recht oder Rechte Dritter verletzt werden. Die
							Entscheidungen der Danone sind endgültig. Diesbezügliche Anfragen können
							nicht beantwortet werden. Die Danone behält sich das Recht vor, die Aktion ganz
							oder zeitweise auszusetzen, wenn irgendwelche Umstände auftreten, die die
							Integrität der Aktion gefährden oder etwaigen rechtlichen Gründen
							entgegenstehen.
						</p>
						<p className="mb-4 text-blue" >Danone behält sich ferner das Recht vor, die Teilnahmebedingungen jederzeit zu
							ändern. Sollten einzelne Bestimmungen der Teilnahmebedingungen ungültig sein
							oder ungültig werden, bleibt die Gültigkeit der übrigen Teilnahmebedingungen
							unberührt. An ihre Stelle tritt die gültige Regelung, die dem Zweck der
							unwirksamen Bestimmung am ehesten entspricht.
						</p>
						<p className="mb-4 text-blue" >
							Jegliche Schadenersatzverpflichtung der Danone und ihrer Organe, Mitarbeiter
							und Erfüllungsgehilfen aus oder im Zusammenhang mit der Cashback Aktion,
							gleich aus welchem Rechtsgrund, ist – soweit gesetzlich zulässig – auf Fälle von
							Vorsatz oder grober Fahrlässigkeit beschränkt.
						</p>
						<p className="mb-4 text-blue" >
							Es gilt deutsches Recht. Der Rechtsweg ist ausgeschlossen.
						</p>
						<h3 className="h3 py-4 text-blue">5. Haftung</h3>
						<p className="mb-4 text-blue" >
							Danone wird nach Erstattung des Kaufpreises von allen Verpflichtungen befreit,
							sofern sich nicht aus diesen Regelungen schon ein früherer Zeitpunkt ergibt. Eine
							Schadensersatzpflicht von Danone besteht nur, wenn und soweit ein Schaden auf
							Vorsatz oder grobe Fahrlässigkeit zurückzuführen ist. Für die schuldhafte
							Verletzung von Leib, Leben oder Gesundheit einer natürlichen Person haftet
							Danone auch bei nur einfacher Fahrlässigkeit. Gleiches gilt im Falle der Verletzung
							einer Kardinalpflicht. Das sind solche Pflichten, deren Erfüllung die
							ordnungsgemäße Durchführung der Aktion und die Erreichung des
							Vertragszwecks überhaupt erst ermöglichen und auf deren Einhaltung ein
							Aktionsteilnehmer regelmäßig vertrauen darf. Voranstehende
							Haftungsbeschränkung gilt insbesondere für Schäden, die durch Fehler,
							Verzögerungen oder Unterbrechungen in der Übermittlung von Daten, bei
							Störungen der technischen Anlagen oder des Service, durch unrichtige Inhalte,
							Verlust oder Löschung von Daten, Viren oder in sonstiger Weise bei der Teilnahme
							an der Cashback Aktion entstehen. Die Haftung nach dem Produkthaftungsgesetz
							bleibt unberührt.{" "}
						</p>
						<h3 className="h3 py-4 text-blue">6. Rechtlicher Rahmen  </h3>
						<p className="mb-4 text-blue" >
							Diese Teilnahmebedingungen sowie die Rechtsbeziehung zwischen dem
							Teilnehmer und Danone unterliegen ausschließlich deutschem Recht. Sollten
							einzelne Bestimmungen rechtlich ungültig sein oder werden, bleibt die Gültigkeit
							der übrigen Teilnahmebedingungen hiervon unberührt. Diese
							Teilnahmebedingungen können von Danone jederzeit ohne gesonderte
							Benachrichtigung geändert werden. Danone behält sich vor, die Aktion auch ohne
							Angabe von Gründen zu verlängern oder vorzeitig gegebenenfalls ohne
							Vorankündigung zu beenden bzw. die Zahl der Einlösungen im Verlauf der Aktion
							nachträglich zu limitieren. Dies kann insbesondere dann erfolgen, sollten
							Fehlfunktionen, Störungen, Fälschungen, Viren oder ähnliche Schäden auftreten
							oder ein Fall des Missbrauchs der Aktion vorliegen und die Administration,
							Sicherheit, Fairness, Integrität oder den Ablauf der Aktion beeinträchtigen. Aus
							vorzeitiger Beendigung können keine Ansprüche abgeleitet werden. Die
							Teilnahmebedingungen gelten für die Dauer der Aktion.
						</p>
						<h3 className="h3 py-4 text-blue">7. Hinweise zum Datenschutz </h3>
						<p className="mb-4 text-blue" >
							(1) Verantwortlicher für die Erhebung, Verarbeitung und Nutzung der Daten ist Danone Deutschland GmbH, Am Hauptbahnhof 18, 60329 Frankfurt am Main, Deutschland. Die Kontaktdaten des Datenschutzbeauftragten von Danone Deutschland lauten:
							Für DE: M. Linder (ebDSB DANONE) c/o intersoft consulting services AG, Beim Strohhause 17, 20097 Hamburg, <a href="mailto:MLinder@intersoft-consulting.de" target="_blank" className="underline">MLinder@intersoft-consulting.de</a>

						</p>
						<p className="mb-4 text-blue" >
							(2) Zweck der Datenverarbeitung<br />

							Der Schutz Ihrer Daten ist uns wichtig. Danone respektiert die Privatsphäre aller
							Personen, die an der Cashback-Aktion teilnehmen. Die Verarbeitung Ihrer
							personenbezogenen Daten erfolgt zum Zweck der Durchführung der Cashback
							Aktion, insbesondere zur Prüfung der Teilnahmevoraussetzungen, zur Validierung
							der eingereichten Kaufbelege sowie zur Abwicklung der Rückzahlung (Cashback).
							Darüber hinaus dient die Verarbeitung der Optimierung unserer
							Marketingmaßnahmen. Rechtsgrundlage für die Verarbeitung ist Art. 6 Abs. 1 lit.
							b) DSGVO (Vertragserfüllung) sowie Art. 6 Abs. 1 lit. f) DSGVO (berechtigtes
							Interesse an der Verbesserung unserer Marketingaktivitäten). Die Bereitstellung
							der personenbezogenen Daten ist für die Teilnahme an der Cashback-Aktion
							erforderlich. Eine Nichtbereitstellung kann zur Folge haben, dass eine Teilnahme
							nicht möglich ist. Im Rahmen der Aktion werden eingereichte Kaufbelege mit Hilfe
							eines KI-gestützten Systems verarbeitet. Dieses System extrahiert strukturierte
							Informationen wie Produktname, Kaufdatum, Preis und Händler, um die
							Teilnahmevoraussetzungen (z. B. Aktionsprodukt, Aktionszeitraum) automatisiert
							zu prüfen und die Teilnahme zu validieren. Darüber hinaus können die aus den
							Belegen extrahierten Daten in anonymisierter oder pseudonymisierter Form zur
							internen Analyse und zur Erstellung statistischer Auswertungen verwendet werden
							(z. B. mit Tools wie Microsoft Power Automate). Mit der Teilnahme willigen die
							Teilnehmer in die Erhebung, Verarbeitung und Nutzung der von ihnen
							angegebenen personenbezogenen Daten bei Danone zur Abwicklung der Gratis
							Testen Aktion ein. Die Daten der Teilnehmer werden bis zum 15.06.2026
							vollständig gelöscht, sofern keine entgegenstehenden gesetzlichen
							Aufbewahrungsfristen bestehen.
						</p>
						<p className="mb-4 text-blue" >
							(3) Datensicherheit; keine Weitergabe an Dritte <br />

							Die personenbezogenen Daten der Teilnehmer werden bei Danone mit geeigneten
							technischen und organisatorischen Maßnahmen gesichert, um die Daten gegen
							zufällige oder vorsätzliche Manipulationen, teilweisen oder vollständigen Verlust,
							Zerstörung oder gegen den unbefugten Zugriff Dritter zu schützen. Die
							Sicherheitsmaßnahmen von Danone werden entsprechend der technologischen
							Entwicklung fortlaufend verbessert. Zugriff auf die Daten hat nur Danone. Eine
							Weitergabe an Dritte erfolgt nicht.
						</p>
						<p className="mb-4 text-blue" >
							(4) Widerruf der Einwilligung<br />

							Die Teilnehmer können ihre Einwilligung zur Erhebung, Verarbeitung und Nutzung
							ihrer personenbezogenen Daten bei Danone jederzeit für die Zukunft widerrufen.
							Der Widerruf ist zu richten an: Im Fall des Widerrufs ist die Teilnahme an der Gratis
							Testen Aktion nicht mehr möglich.
						</p>
						<p className="mb-4 text-blue" >
							(5) Weitere Rechte der Teilnehmer<br />

							Teilnehmer haben außerdem das Recht:<br />

							- gemäß Art. 15 DSGVO Auskunft über die verarbeiteten personenbezogenen
							Daten zu verlangen. Insbesondere können sie Auskunft über die
							Verarbeitungszwecke, die Kategorie der personenbezogenen Daten, die
							Kategorien von Empfängern, gegenüber denen ihre Daten offengelegt wurden
							oder werden, die geplante Speicherdauer, das Bestehen eines Rechts auf
							Berichtigung, Löschung, Einschränkung der Verarbeitung oder Widerspruch, das
							Bestehen eines Beschwerderechts, die Herkunft ihrer Daten, sofern diese nicht bei
							Danone erhoben wurden, sowie über das Bestehen einer automatisierten
							Entscheidungsfindung einschließlich Profiling und ggf. aussagekräftigen
							Informationen zu deren Einzelheiten verlangen;
						</p>
						<p className="mb-4 text-blue" >
							- gemäß Art. 16 DSGVO unverzüglich die Berichtigung unrichtiger oder
							Vervollständigung ihrer gespeicherten personenbezogenen Daten zu verlangen;
						</p>
						<p className="mb-4 text-blue" >
							- gemäß Art. 17 DSGVO die Löschung der gespeicherten personenbezogenen
							Daten zu verlangen, soweit nicht die Verarbeitung zur Ausübung des Rechts auf
							freie Meinungsäußerung und Information, zur Erfüllung einer rechtlichen
							Verpflichtung, aus Gründen des öffentlichen Interesses oder zur Geltendmachung,
							Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist;
						</p>
						<p className="mb-4 text-blue" >
							- gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung ihrer
							personenbezogenen Daten zu verlangen, soweit die Richtigkeit der Daten vom
							Teilnehmer bestritten wird, die Verarbeitung unrechtmäßig ist, die Teilnehmer
							aber die Löschung ablehnen;
						</p>
						<p className="mb-4 text-blue" >
							- gemäß Art. 20 DSGVO ihre personenbezogenen Daten, die sie uns bereitgestellt
							haben, in einem strukturierten, gängigen und maschinenlesebaren Format zu
							erhalten oder die Übermittlung an einen anderen Verantwortlichen zu verlangen.
							Das vorgenannte Verlangen auf Auskunft, Berichtigung, Vervollständigung,
							Löschung, Einschränkung der Verarbeitung, Erhalt der Daten bzw. Übermittlung
							an einen anderen Verantwortlichen sind zu richten an:  <a href="mailto:info@gratistesten.alpro.com " target="_blank" className="underline">info@gratistesten.alpro.com</a>.
						</p>
						<p className="mb-4 text-blue" >
							(6) Beschwerderecht<br />

							Falls Teilnehmer der Ansicht sein sollten, dass Danone bei der Verarbeitung der
							personenbezogenen Daten gegen datenschutzrechtliche Bestimmungen verstößt,
							können sie sich bei einer Aufsichtsbehörde beschweren. Zuständig sind die
							Aufsichtsbehörden in dem Mitgliedstaat des Aufenthaltsorts oder Arbeitsplatzes
							der Teilnehmer oder die Aufsichtsbehörden am Ort des mutmaßlichen Verstoßes.
						</p>
						<p className="mb-4 text-blue" >
							Fragen und Anmerkungen zur Aktion oder den Teilnahmebedingungen können in schriftlicher Form an <a href="mailto:info@gratistesten.alpro.com " target="_blank" className="underline">info@gratistesten.alpro.com</a> geschickt werden.

						</p>
					</div>
					<div className=" py-10 pt-5 text-center text-xl text-blue">
						<Link
							to="/"
							className="mb-6 mt-12 block w-[100%] bg-blue p-4 font-Alpro text-[24px] font-bold uppercase tracking-wider text-white drop-shadow-md sm:w-[auto] md:text-[32px] trackind-wider rounded-full border-[3px] border-white lg:inline-block lg:py-2 lg:px-6"
						>
							Zurück
						</Link>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	)
}
export default Terms
